import styled from "styled-components";
import { COLORS } from "../../constants/Styles";

export const SelectContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: ${COLORS.black};
  padding: 0.25rem;
  border-radius: 1.25rem;
  justify-content: space-between;
  gap: 0.25rem 1rem;
  flex-wrap: wrap;
`;

export const SelectOption = styled.div<{
  isSelected: boolean;
  fontSize: string;
}>`
  position: relative;
  color: ${({ isSelected }) =>
    isSelected ? COLORS.secondary : COLORS.secondaryLight};
  cursor: pointer;
  border-radius: 1.25rem;
  padding: 0.5rem 1rem;
  white-space: nowrap;
  font-size: ${({ fontSize }) => fontSize};
  background-color: ${({ isSelected }) =>
    isSelected ? COLORS.inputGray : COLORS.black};
`;
